<template src="./task.html"></template>

<script>
  import axios from 'axios'
  import SettingSidebar from '../common/settingsidebar/settingsidebar'
  import auth from '../../helpers/auth'
  import { formatTaskTypeDisplay } from '../../helpers/taskTypes'

  export default {
    name: 'task',
    components: {
      'app-setting-sidebar': SettingSidebar
    },
    data: function () {
      return {
        tasks: [],
        loading: false,
        searchText: '',
        searchResults: [],
        filterType: null,
        paginator: {
          page: 1,
          totalPages: 0,
          nextPage: 0,
          previousPage: 0
        },
        type: 'default',
        timeout: null
      }
    },
    methods: {
      onPageChange: function (page) {
        if (this.filterType) {
          this.filterByType(this.filterType, page)
        } else {
          this.getTasks(page)
        }
      },
      getTasks: function (page = 1) {
        this.loading = true
        axios.get('/api/tasks?page=' + page + '&type=' + this.type + '&_t=' + Date.now()).then(response => {
          this.tasks = (response.data.items || []).map(function (t) {
            return Object.assign({}, t, { default: t.company_id == null })
          })
          const apiPagination = response.data.pagination || { page: 1, total: 0, pages: 0 }
          const currentPage = apiPagination.page || 1
          const totalPages = apiPagination.totalPages || apiPagination.pages || Math.ceil((apiPagination.total || 0) / (apiPagination.limit || 10)) || 0
          this.paginator = {
            page: currentPage,
            totalPages,
            previousPage: currentPage > 1 ? currentPage - 1 : 0,
            nextPage: currentPage < totalPages ? currentPage + 1 : 0
          }
          this.loading = false
        })
      },
      newTask: function () {
        this.$router.push('/settings/task/new')
      },
      viewTask: function (task) {
        this.$router.push('/settings/task/' + task.id)
      },
      getImageUrl: function (item) {
        if (!item || !item.images || !Array.isArray(item.images) || item.images.length === 0) {
          return '../../assets/img/no-image-available.jpg'
        }
        const image = item.images[0]
        return image.pending
          ? this.$store.getters['getImageUrl'] + 'pending/' + image.filename
          : this.$store.getters['getImageUrl'] + image.filename
      },
      search: function () {
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
          if (this.searchText && this.searchText.length >= 2) {
            this.loading = true
            axios.post(`/api/tasks/fetch/search?type=${this.type}`, { text: this.searchText }).then(response => {
              this.searchResults = response.data.items
              this.loading = false
            })
          } else {
            this.searchResults = []
          }
        }, 1000)
      },
      filterByType: function (type, page = 1) {
        if (type) {
          this.filterType = type
          this.loading = true
          axios.post(`/api/tasks/fetch/type?page=${page}&type=${this.type}`, { type: type }).then(response => {
            this.searchResults = response.data.items
            this.paginator = response.data.pagination
            this.loading = false
          })
        } else {
          this.filterType = null
          this.searchResults = []
        }
      },
      formatTaskType: function (type, template) {
        return formatTaskTypeDisplay(type, template)
      }
    },
    watch: {
      type () {
        this.getTasks()
      }
    },
    created: function () {
      auth.check(this)
      let page = this.$route.query.page
      this.getTasks(page)
    },
    mounted: function () {
      $(this.$el).find('.ui.menu .item').tab()
    }
  }
</script>

<style scoped>
/* Empty state styling */
.empty-state-container {
  background: var(--color-bg-document-card);
  border: 1px solid var(--color-border-document-card);
  border-radius: 4px;
  padding: 40px 20px;
  text-align: center;
  margin: 20px 0;
}

.empty-state-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.empty-state-title {
  font-family: var(--font-semibold);
  font-size: 18px;
  font-weight: 600;
  color: var(--color-text);
  margin: 0 0 8px 0;
}

.empty-state-description {
  font-family: var(--font-semibold);
  font-size: 14px;
  color: var(--color-text-muted);
  margin: 0;
  line-height: 1.4;
}

/* Remove hover effects from task list rows */
.ui.table tbody tr.show-view-task-all:hover {
  background-color: transparent !important;
}

.ui.table tbody tr.show-view-task-all:hover td {
  background-color: transparent !important;
}

/* Remove hover effects from empty state row */
.ui.table tbody tr.empty-state-row:hover {
  background-color: transparent !important;
}

.ui.table tbody tr.empty-state-row:hover td {
  background-color: transparent !important;
}
</style>
